export default __webpack_public_path__ + "static/media/no-data-white.665ba946.svg";